import { Component, computed, input, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  templateUrl: 'action-ended.component.html',
  styleUrls: ['./action-ended.component.scss'],
  standalone: true,
  encapsulation: ViewEncapsulation.None,
})
export class ActionEndedComponent {
  public readonly modalCommunicate = input.required<string>();

  public readonly sanitizedText = computed(() =>
    this.modalCommunicate() ? this._domSanitizer.bypassSecurityTrustHtml(this.modalCommunicate() || '') : null,
  );

  constructor(
    private readonly _domSanitizer: DomSanitizer,
    private readonly _ngbActiveModal: NgbActiveModal,
  ) {}

  public onClose(): void {
    this._ngbActiveModal.close(false);
  }
}
